import * as React from 'react'

export const AlignLeftIcon = React.memo(
  ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.71094 5.83398C2.71094 5.48881 2.99076 5.20898 3.33594 5.20898H16.6693C17.0144 5.20898 17.2943 5.48881 17.2943 5.83398C17.2943 6.17916 17.0144 6.45898 16.6693 6.45898H3.33594C2.99076 6.45898 2.71094 6.17916 2.71094 5.83398ZM2.71094 10.0007C2.71094 9.65547 2.99076 9.37565 3.33594 9.37565H12.5026C12.8478 9.37565 13.1276 9.65547 13.1276 10.0007C13.1276 10.3458 12.8478 10.6257 12.5026 10.6257H3.33594C2.99076 10.6257 2.71094 10.3458 2.71094 10.0007ZM2.71094 14.1673C2.71094 13.8221 2.99076 13.5423 3.33594 13.5423H7.5026C7.84778 13.5423 8.1276 13.8221 8.1276 14.1673C8.1276 14.5125 7.84778 14.7923 7.5026 14.7923H3.33594C2.99076 14.7923 2.71094 14.5125 2.71094 14.1673Z" fill="currentColor"/>
</svg>
    )
  },
)

AlignLeftIcon.displayName = 'AlignLeftIcon'
